interface UserLike {
  name?: string | null;
  email?: string | null;
}

/**
 * Computes display initials from a user's name (first letter of first word +
 * first letter of last word). Falls back to the first letter of the email
 * when name is missing. Returns an empty string when both are missing.
 */
export function getAvatarInitials(user: UserLike): string {
  const name = user.name?.trim();
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length === 1) {
      return parts[0]!.slice(0, 1).toUpperCase();
    }
    const first = parts[0]!.slice(0, 1);
    const last = parts[parts.length - 1]!.slice(0, 1);
    return (first + last).toUpperCase();
  }

  const email = user.email?.trim();
  if (email) {
    return email.slice(0, 1).toUpperCase();
  }

  return '';
}
